module.exports = __webpack_public_path__ + "static/media/adrian-korte-76051-unsplash.496e91cc.jpg";